module.exports = __webpack_public_path__ + "static/media/First National Bank South Africa_.ee38965d.jpg";